"use client";

import useSWR from "swr";

interface ErpConnection {
  id: string;
  erp_type: string;
  name: string;
  [key: string]: unknown;
}

const EMPTY: ErpConnection[] = [];

export function useConnections() {
  const { data, error, isLoading, mutate } = useSWR<ErpConnection[]>(
    "/api/erp-connections",
    { revalidateOnFocus: false }
  );

  return {
    connections: data ?? EMPTY,
    isLoading,
    error,
    mutate,
  };
}

export function useConnection(id: string | null) {
  const { data, error, isLoading, mutate } = useSWR<ErpConnection>(
    id ? `/api/erp-connections/${id}` : null,
    { revalidateOnFocus: false }
  );

  return {
    connection: data ?? null,
    isLoading,
    error,
    mutate,
  };
}
